/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


const STORAGE_KEY = 'solis.preferences';


export const readStorage = () =>
{
  const value = window.localStorage.getItem(STORAGE_KEY);

  return value ? JSON.parse(value) : {};
};


export const writeStorage = (state) =>
{
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));

  return state;
};
